import { useGetChannelListChannelListGetQuery } from '@shared/api';
import { useAppSelector } from '@shared/redux';
import { authSelectors } from '@shared/redux/ducks/auth';

export const useGetChannels = () => {
  const currentOrganization = useAppSelector(authSelectors.selectCurrentOrganizationInfo);

  const { data, isLoading, isFetching, isError, refetch } = useGetChannelListChannelListGetQuery({
    organizationId: currentOrganization.id,
  });

  const isEmpty = !data || data.length === 0;
  const count = data?.length ?? 0;

  return {
    channels: data,
    count,
    isEmpty,
    isLoading,
    isFetching,
    isError,
    refetch,
  };
};
